<template>
  <div class="p-6 bg-blue-dark h-full flex flex-col justify-between">
    <div class="flex justify-end px-2 mb-6">
      <button
        @click="handleChangeUnitTemperatureToCelsius"
        class="h-10 w-10 mr-3 rounded-full border-2 border-transparent focus:outline-none font-semibold"
        :class="styleButton('C')"
      >
        <span>°C</span>
      </button>
      <button
        @click="handleChangeUnitTemperatureToFahrenheit"
        class="h-10 w-10 rounded-full border-2 border-transparent focus:outline-none font-semibold"
        :class="styleButton('F')"
      >
        <span>°F</span>
      </button>
    </div>
    <div class="p-3 mb-6 grid grid-cols-12 gap-y-3 gap-x-5 md:grid-cols-9 lg:grid-cols-10">
      <div
        class="col-span-6 md:col-span-3 lg:col-span-2"
        v-for="forecast in weatherForecast.nextDays"
        :key="forecast.title"
      >
        <NextDaysWeatherCard
          :title="forecast.date"
          :temperature="forecast.temperature"
          :currentTemperatureUnit="unitTemperature"
          :state="forecast.state"
        />
      </div>
    </div>
    <div>
      <h3 class="mb-3 text-gray-light text-2xl font-bold">Today's Highlights</h3>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div class="px-3 py-4 col-span-1 bg-blue-DEFAULT">
          <div class="flex flex-col items-center">
            <h3 class="mb-3 text-gray-light text-base font-medium">
              Wind status
            </h3>
            <p class="mb-3 text-gray-light">
              <span class="text-6xl font-bold">{{weatherForecast.currentDay.wind.speed}}</span>
              <span class="ml-1 text-3xl">mph</span>
            </p>
            <div class="flex items-center">
              <div class="p-2 rounded-full transform rotate-215 bg-gray-dark">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-light" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                </svg>
              </div>
              <span class="ml-3 text-gray-light text-sm">{{weatherForecast.currentDay.wind.direction}}</span>
            </div>
          </div>
        </div>
        <div class="px-3 py-4 col-span-1 bg-blue-DEFAULT">
          <div class="flex flex-col items-center">
            <h3 class="mb-3 text-gray-light text-base font-medium">
              Hunidity
            </h3>
            <p class="mb-3 text-gray-light">
              <span class="text-6xl font-bold">{{weatherForecast.currentDay.humidity}}</span>
              <span class="ml-1 text-3xl">%</span>
            </p>
            <div class="w-full max-w-xs">
              <ProgressBar :progress="weatherForecast.currentDay.humidity"/>
            </div>
          </div>
        </div>
        <div class="px-3 py-4 col-span-1 bg-blue-DEFAULT">
          <div class="flex flex-col items-center">
            <h3 class="mb-3 text-gray-light text-base font-medium">
              Visibility
            </h3>
            <p class="text-gray-light">
              <span class="text-6xl font-bold">{{weatherForecast.currentDay.visibility}}</span>
              <span class="ml-1 text-3xl">miles</span>
            </p>
          </div>
        </div>
        <div class="px-3 py-4 col-span-1 bg-blue-DEFAULT">
          <div class="flex flex-col items-center">
            <h3 class="mb-3 text-gray-light text-base font-medium">
              Air pressure
            </h3>
            <p class="text-gray-light">
              <span class="text-6xl font-bold">{{weatherForecast.currentDay.air_pressure}}</span>
              <span class="ml-1 text-3xl">mb</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6 text-gray-DEFAULT text-center">
      created by <a class="font-bold" target="_blank" href="https://github.com/r10rivas/">r10rivas</a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NextDaysWeatherCard from "./nextDaysWeatherCard";
import ProgressBar from "./progressBar";

export default {
  name: "NextDaysWeather",
  components: {
    NextDaysWeatherCard,
    ProgressBar,
  },
  computed: {
    ...mapState(["unitTemperature", "weatherForecast"])
  },
  methods: {
    styleButton (unitTemperature) {
      if (unitTemperature == this.unitTemperature) {
        return "bg-gray-light text-gray-dark pointer-events-none"
      }
      return "bg-gray-dark text-gray-light hover:bg-gray-darker"
    },
    handleChangeUnitTemperatureToFahrenheit () {
      this.$store.dispatch("changeUnitTemperatureToFahrenheit");
    },
    handleChangeUnitTemperatureToCelsius () {
      this.$store.dispatch("changeUnitTemperatureToCelsius");
    }
  },
}
</script>
